
document.addEventListener("DOMContentLoaded", function () {
  const mq = window.matchMedia("(max-width: 799px)");

  function initFooterAccordion() {
    if (!mq.matches) return;

    const blocks = document.querySelectorAll(
      ".footer__blocks-wrapper .footer-block"
    );

    blocks.forEach((block) => {
      const heading = block.querySelector(".footer-block__heading");
      const list = block.querySelector(".footer-block__details-content");

      if (!heading || !list) return;

      // Accessibility
      heading.setAttribute("role", "button");
      heading.setAttribute("tabindex", "0");
      heading.setAttribute("aria-expanded", "false");

      heading.addEventListener("click", toggle);
      heading.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggle();
        }
      });

      function toggle() {
        const isOpen = block.classList.contains("is-open");

        // close others
        blocks.forEach((b) => {
          b.classList.remove("is-open");
          const h = b.querySelector(".footer-block__heading");
          h && h.setAttribute("aria-expanded", "false");
        });

        // toggle current
        if (!isOpen) {
          block.classList.add("is-open");
          heading.setAttribute("aria-expanded", "true");
        }
      }
    });
  }

  initFooterAccordion();
});



// for mobile expand menu
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.site-mega-menu-simple-links-item');

  // Helper to close all dropdowns
  function closeAll() {
    document.querySelectorAll('.sub-drop-down.open').forEach(dd => dd.classList.remove('open'));
    document.querySelectorAll('.site-mega-menu-simple-links-item span.h3 svg.rotated')
            .forEach(svg => svg.classList.remove('rotated'));
  }

  items.forEach(item => {
    const title = item.querySelector('span.h3');
    const dropdown = item.querySelector('.sub-drop-down');
    const svg = title ? title.querySelector('svg') : null;

    // if no title/dropdown, skip
    if (!title || !dropdown) return;

    title.addEventListener('click', (ev) => {
      ev.stopPropagation(); // don't trigger document click handler

      const isOpen = dropdown.classList.contains('open');

      // close others first
      items.forEach(other => {
        if (other !== item) {
          const otherDd = other.querySelector('.sub-drop-down');
          const otherSvg = other.querySelector('span.h3 svg');
          if (otherDd) otherDd.classList.remove('open');
          if (otherSvg) otherSvg.classList.remove('rotated');
        }
      });

      // toggle this one
      if (isOpen) {
        dropdown.classList.remove('open');
        if (svg) svg.classList.remove('rotated');
      } else {
        dropdown.classList.add('open');
        if (svg) svg.classList.add('rotated');
      }
    });
  });

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.site-mega-menu-simple-links-item')) {
      closeAll();
    }
  });

  // Optional: close with Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
});





// for mobile menu alphabet scroll
document.addEventListener('click', function(e) {
  const link = e.target.closest('.alpha-link');
  if (!link) return;

  e.preventDefault();

  const letter = link.dataset.letter;
  console.log('[DEBUG] Clicked letter:', letter);

  const container = document.querySelector('.alpha-menu');
  if (!container) {
    console.warn('[DEBUG] .alpha-menu container not found');
    return;
  }
  console.log('[DEBUG] Scroll container found:', container);

  const target = container.querySelector(`.alpha-group[data-group="${letter}"]`);
  if (!target) {
    console.warn('[DEBUG] No alpha-group found for letter:', letter);
    return;
  }
  console.log('[DEBUG] Target element found:', target);

  // Calculate offsetTop relative to container
  let scrollTop = 0;
  let node = target;
  while (node && node !== container) {
    scrollTop += node.offsetTop;
    node = node.offsetParent;
  }
  console.log('[DEBUG] Calculated scrollTop:', scrollTop);

  container.scroll({
    top: scrollTop,
    behavior: 'smooth'
  });

  console.log('[DEBUG] Scroll executed');
});

(function () {
  function getSearchContext(target) {
    const form = target.closest(".search-modal__form");
    if (!form) return null;

    return {
      form,
      input: form.querySelector('input[type="search"]'),
      box: form.querySelector(".predictive-search-box"),
      rec: form.querySelector(".predictive-search__rec-wrapper")
    };
  }

  function closeSearch(ctx) {
    if (!ctx || !ctx.box || !ctx.input) return;

    ctx.box.classList.remove("is-open");
    ctx.input.value = "";
    ctx.input.setAttribute("aria-expanded", "false");

    if (ctx.rec) ctx.rec.classList.remove("is-hidden");

    // reset Dawn predictive-search
    ctx.input.dispatchEvent(new Event("input", { bubbles: true }));
    ctx.input.blur();
  }

  /* OPEN on input click / focus */
  document.addEventListener("click", function (e) {
    const input = e.target.closest("#simple-search-header");
    if (!input) return;

    const ctx = getSearchContext(input);
    if (!ctx || !ctx.box) return;

    ctx.box.classList.add("is-open");
    input.setAttribute("aria-expanded", "true");
  });

  document.addEventListener("focusin", function (e) {
    const input = e.target.closest("#simple-search-header");
    if (!input) return;

    const ctx = getSearchContext(input);
    if (!ctx || !ctx.box) return;

    ctx.box.classList.add("is-open");
    input.setAttribute("aria-expanded", "true");
  });

  /* HANDLE RECOMMENDATION VISIBILITY */
  function updateRecommendations(ctx) {
    if (!ctx || !ctx.rec || !ctx.input) return;

    // Hide recommendations ONLY if user typed something
    ctx.rec.classList.toggle("is-hidden", ctx.input.value.trim().length > 0);
  }

  /* KEYUP → hide / show recommended */
  document.addEventListener("keyup", function (e) {
    const input = e.target.closest(".search-modal__form input[type='search']");
    if (!input) return;

    const ctx = getSearchContext(input);
    updateRecommendations(ctx);
  });

  /* INITIAL CHECK on page load */
  document.addEventListener("DOMContentLoaded", function () {
    const input = document.querySelector(".search-modal__form input[type='search']");
    if (!input) return;

    const ctx = getSearchContext(input);
    updateRecommendations(ctx);
  });

  /* CLOSE button */
  document.addEventListener("click", function (e) {
    const closeBtn = e.target.closest("#close_psb");
    if (!closeBtn) return;

    const ctx = getSearchContext(closeBtn);
    closeSearch(ctx);
  });

  /* ESC key */
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;

    const openBox = document.querySelector(".predictive-search-box.is-open");
    if (!openBox) return;

    const ctx = getSearchContext(openBox);
    closeSearch(ctx);
  });

  /* CLOSE when clicking outside */
document.addEventListener("click", function (e) {
  const openBox = document.querySelector(".predictive-search-box.is-open");
  if (!openBox) return;

  // If click is inside search form or predictive box → ignore
  if (e.target.closest(".search-modal__form")) return;
  if (e.target.closest(".predictive-search-box")) return;

  const ctx = getSearchContext(openBox);
  closeSearch(ctx);
});

})();

// for deskop search
document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector(".search-modal__form");
  if (!form) return;

  const input = form.querySelector('input[type="search"]');
  const recWrapper = form.querySelector(".predictive-search__rec-wrapper");

  if (!input || !recWrapper) return;

  input.addEventListener("keyup", function () {
    const hasValue = input.value.trim().length > 0;
    recWrapper.classList.toggle("is-hidden", hasValue);
  });

  const resetBtn = form.querySelector('button[type="reset"]');
if (resetBtn) {
  resetBtn.addEventListener("click", () => {
    recWrapper.classList.remove("is-hidden");
  });
}

});

// recent view product
  (function() {
    if (!window.location.pathname.includes('/products/')) return;

    // Get the product handle from the URL
    var handle = window.location.pathname.split('/products/')[1];

    // Read stored history
    var recent = JSON.parse(localStorage.getItem('recent_products') || "[]");

    // Remove if already exists
    recent = recent.filter(function(h) { return h !== handle; });

    // Add to front
    recent.unshift(handle);

    // Limit to 5 items
    if (recent.length > 5) recent.pop();

    // Save back
    localStorage.setItem('recent_products', JSON.stringify(recent));
  })();





  // headerlocal
  document.querySelectorAll('.tab-btn').forEach(btn=>{
  btn.addEventListener('click', function(){

    document.querySelectorAll('.tab-btn').forEach(b=>b.classList.remove('active'));
    document.querySelectorAll('.tab-content').forEach(c=>c.classList.remove('active'));

    this.classList.add('active');
    document.getElementById(this.dataset.tab).classList.add('active');

  })
});

document.addEventListener("DOMContentLoaded", function () {

  const toggle = document.querySelector(".localization-toggle");
  const drawer = document.getElementById("localization-drawer");
  const overlay = document.querySelector(".drawer-overlay");
  const drawerContent = document.querySelector(".drawer-content");

  if(!toggle || !drawer) return;

  function openDrawer(){
    drawer.classList.add("active");
    toggle.classList.add("open");
    document.body.classList.add("drawer-open");
  }

  function closeDrawer(){
    drawer.classList.remove("active");
    toggle.classList.remove("open");
    document.body.classList.remove("drawer-open");
  }

  toggle.addEventListener("click", function(e){
    e.stopPropagation();

    if(drawer.classList.contains("active")){
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  if(overlay){
    overlay.addEventListener("click", closeDrawer);
  }

  document.addEventListener("click", function(e){

    if(
      drawer.classList.contains("active") &&
      !drawerContent.contains(e.target) &&
      !toggle.contains(e.target)
    ){
      closeDrawer();
    }

  });

  document.addEventListener("keydown", function(e){
    if(e.key === "Escape"){
      closeDrawer();
    }
  });

});

// mob
document.addEventListener("DOMContentLoaded", function () {

  const toggle = document.querySelector(".localization-toggle-mbl");
  const drawer = document.getElementById("loc-drawer");

  const overlay = drawer ? drawer.querySelector(".loc-drawer__overlay") : null;
  const content = drawer ? drawer.querySelector(".loc-drawer__content") : null;
  const closeBtn = drawer ? drawer.querySelector(".loc-drawer__close") : null;

  if (!toggle || !drawer) return;

  function openDrawer() {
    drawer.classList.add("active");
    toggle.classList.add("open");
    document.body.classList.add("drawer-open");
  }

  function closeDrawer() {
    drawer.classList.remove("active");
    toggle.classList.remove("open");
    document.body.classList.remove("drawer-open");
  }

  toggle.addEventListener("click", function (e) {
    e.stopPropagation();
    drawer.classList.contains("active") ? closeDrawer() : openDrawer();
  });

  if (overlay) overlay.addEventListener("click", closeDrawer);
  if (closeBtn) closeBtn.addEventListener("click", closeDrawer);

  document.addEventListener("click", function (e) {
    if (
      drawer.classList.contains("active") &&
      content &&
      !content.contains(e.target) &&
      !toggle.contains(e.target)
    ) {
      closeDrawer();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  /* Tabs */
  const tabs = drawer.querySelectorAll(".loc-drawer__tab-btn");
  const contents = drawer.querySelectorAll(".loc-drawer__tab-content");

  tabs.forEach(btn => {
    btn.addEventListener("click", function () {
      const target = btn.dataset.tab;

      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      btn.classList.add("active");

      const activeContent = drawer.querySelector(`#${target}`);
      if (activeContent) activeContent.classList.add("active");
    });
  });

});